import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { Delete, Warning } from "@mui/icons-material";
import AlertDialog from "../mui/dialog";
import DropdownMenu from "../mui/dropdown";
import SearchField from "../mui/SearchField";
import React, { useEffect, useState } from "react";
import { getRegions } from "../data/models/GlobalAdmin";
import CustomDropdownMenu from "../mui/dropdown";

export default function ApprovedTable({ width, data, onKitchenSelection }) {
  const [warning, setWarning] = useState(false);

  const [region, setRegion] = useState("");
  const [subRegion, setSubRegion] = useState("");

  const [regionsList, setRegionsList] = useState([]);
  const [subRegionsList, setSubRegionsList] = useState([]);

  const [isWarning, setIsWarning] = useState(false);
  const [isLoading, setIsLoading] = useState(false);



  function getRegionFromName(n) {
    var region = null;
    console.log(regionsList);
    for (let i = 0; i < regionsList.length; i++) {
      if (n === regionsList[i].name) {
        region = regionsList[i];
      }
    }
    // console.log(region)
    return region;
  }

  function getNamesFromRegions(list) {
    return list?.map((data) => {
      return data.name;
    });
  }

  function onRegionSelection(selectedNamedRegion) {
    setRegion(selectedNamedRegion);
    var sList = getRegionFromName(selectedNamedRegion).subregions;
   
    setSubRegionsList(sList);
  }

  function onSubRegionSelection(selectedNamedSubRegion) {
    setSubRegion(selectedNamedSubRegion);
  }


  function loadData() {
    setIsLoading(true);
    setIsWarning(false);
    console.log("called");
    getRegions((error2, regions) => {
      if (error2) {
        setIsWarning(true);
        console.log(error2);
        setIsLoading(false);
        return;
      } else {
        setIsLoading(false);
        setIsWarning(false);
        setRegionsList(regions);
        setSubRegionsList(regions[0].subregions);
      }
    });
  }
  useEffect(() => {
    loadData();
  }, []);

  const getFilteredList = (list) => {
    console.log("Zaman:List:", list);

    if (
      region === "" ||
      subRegion === "" ||
      region.toLowerCase().includes("entire m")
    ) {
      const newList = [];

      list?.forEach((x) => {
        var queryCheck =
          x.detail.full_name.toLowerCase().includes(query.toLowerCase()) ||
          x.detail.id.toString().includes(query.toLowerCase()) ||
          query == "";

        if (queryCheck) {
          newList.push(x);
        }
      });
      return newList;
    } else {
      const newList = [];

      list?.forEach((x) => {
        var queryCheck =
          x.detail.full_name.toLowerCase().includes(query.toLowerCase()) ||
          x.detail.id.toString().includes(query.toLowerCase()) ||
          query == "";

        var regionCheck = false;

        if (x.detail.region.toLowerCase().includes("entire m")) {
          regionCheck = true;
        } else if (
          x.detail.region.toLowerCase() == region.toLowerCase() &&
          (x.detail.subregion.toLowerCase() == subRegion.toLowerCase() ||
            subRegion.toLowerCase().includes("all " + region.toLowerCase()))
        ) {
          regionCheck = true;
        }

        if (queryCheck && regionCheck) {
          newList.push(x);
        }
      });
      return newList;
    }
  };

  const [query, setQuery] = React.useState("");

  return (
    <div
      style={{ marginTop: "20px", display: "flex", flexDirection: "column" }}
    >
      <div style={{ display: "flex" }}>
        <CustomDropdownMenu
          onSelection={onRegionSelection}
          width={170}
          label={"Region"}
          value={region}
          list={getNamesFromRegions(regionsList)}
        />
        <CustomDropdownMenu
          onSelection={onSubRegionSelection}
          width={170}
          label={"Sub Region"}
          value={subRegion}
          list={subRegionsList}
        />
        <SearchField setQuery={setQuery} query={query} />
      </div>

      <AlertDialog
        onNoClick={() => setWarning(false)}
        onYesClick={() => setWarning(false)}
        warningMessage={"This action is not reversible, do want to continue?"}
        IconComponent={
          <Warning style={{ color: "orange", marginInlineEnd: "10px" }} />
        }
        visible={warning}
      />

      <TableContainer
        sx={{
          marginInlineStart: "10px",
          marginTop: "12px",
          width: width ?? "95%",
        }}
        component={Paper}
      >
        <Table sx={{ width: "100%" }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "600" }}>ID</TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                VENDOR'S NAME
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                EMAIL
              </TableCell>

              <TableCell style={{ fontWeight: "600" }} align="left">
                PHONE
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                REGION
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                SUB_REGION
              </TableCell>
              <TableCell style={{ fontWeight: "600" }} align="left">
                AC_TYPE
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getFilteredList(data ?? [])?.map((row, index) => (
              <TableRow
                onClick={() => {
                  onKitchenSelection(row?.detail);
                }}
                className="cursor-pointer hover:bg-yellow-200"
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row?.detail?.id}
                </TableCell>
                <TableCell align="left">{row?.detail?.full_name}</TableCell>
                <TableCell align="left">{row?.detail?.email}</TableCell>

                <TableCell align="left">{row?.detail?.phone}</TableCell>
                <TableCell align="left">{row?.detail?.region}</TableCell>
                <TableCell align="left">{row?.detail?.subregion}</TableCell>
                <TableCell align="left">{row?.detail?.account_type}</TableCell>

                <TableCell align="left"></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
